function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  // Sin "/" final: varios lugares arman URLs como `${getBackendUrl()}/public/...`,
  // y VITE_BACKEND_URL ya trae un "/" al final — la doble barra resultante
  // ("//public/...") no la reconoce nginx y responde 404 en vez del archivo.
  const url = getConfig("VITE_BACKEND_URL") || "";
  return url.replace(/\/+$/, "");
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
